import MuiCardContent from "@mui/material/CardContent";

/**
 * Facade over MUI CardContent. Customize defaults here.
 */
export default function CardContent(props) {
  return <MuiCardContent {...props} />;
}
